import { PropsWithChildren, useState } from 'react';
import { FallbackProps } from 'react-error-boundary';

export function ErrorFallBack({ children, error, resetErrorBoundary }: PropsWithChildren<FallbackProps>) {
  const stack = JSON.stringify(error.stack || '');
  const errorMessage = error.message || 'Unknown error';
  const [hideStack, setHideStack] = useState(true);

  function toggleStack() {
    setHideStack(!hideStack);
  }

  return (
    <div className={'ui container'} style={{ margin: '30px' }}>
      <div className={'ui segment'}>
        <h3>Oops...Something went wrong...</h3>
      </div>
      <div className={'ui error message'}>
        {children}
        <div className={'ui segment basic'}>Error Message: {errorMessage}</div>
        {!hideStack ? <div className={'ui segment basic'}>Stack Trace: {stack}</div> : null}
      </div>
      <div>
        <button className="ui button blue" onClick={toggleStack}>
          {hideStack? "Show Stack": "Hide Stack"}
        </button>
        <button className="ui button blue" onClick={resetErrorBoundary}>
          Reset
        </button>
      </div>
    </div>
  );
}
